// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.md-editor-container .w-md-editor-text-input,
.md-editor-container .w-md-editor-text-input:focus {
    border: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/nlp-answer-text-inpit/NlpAnswerTextInput.css"],"names":[],"mappings":"AAAA;;IAEI,SAAS;IACT,wBAAwB;IACxB,gBAAgB;AACpB","sourcesContent":[".md-editor-container .w-md-editor-text-input,\r\n.md-editor-container .w-md-editor-text-input:focus {\r\n    border: 0;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
